import * as tslib_1 from "tslib";
import { MicrocreditoRestService } from '../../../omni-rest/microcredito/microcredito-rest.service';
import { OmniGeralRestService } from '../../../omni-rest/omni-geral/omni-geral-rest.service';
export class MicrocreditoService {
    constructor(restService, restServiceGeral) {
        this.restService = restService;
        this.restServiceGeral = restServiceGeral;
    }
    findByProposta(propostaId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield this.restService.get(`faef/${propostaId}`).toPromise();
                return result.faefVO;
            }
            catch (error) {
                return null;
            }
        });
    }
    save(faef, propostaId) {
        if (faef.proposta) {
            return this.restService.put('faef', { faef }).toPromise();
        }
        faef.proposta = propostaId;
        return this.restService.post('faef', { faef }).toPromise();
    }
    calculate(faef, cliente) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.defineCliente(faef, cliente);
            const result = yield this.restService.post('faef/calculate', { faef }).toPromise();
            if (faef.faefResultado) {
                const { parecerAgente, notaConfiancaCliente, valorEmprestaria } = faef.faefResultado;
                faef.faefResultado = Object.assign({}, result.faefResultadoVO, { parecerAgente, notaConfiancaCliente, valorEmprestaria });
            }
            else {
                faef.faefResultado = result.faefResultadoVO;
            }
            return faef;
        });
    }
    defineCliente(faef, cliente) {
        faef.faefCliente = {
            cliente: cliente.id,
            cpf: cliente.cpf,
            dataNascimento: cliente.dtNascimento,
            estadoCivil: String(cliente.estadoCivil.id),
            grauInstrucao: String(cliente.grauInstrucao),
            nacionalidade: cliente.nacionalidade.id,
            numeroDependentes: cliente.dependentes,
            sexo: cliente.sexo,
            tempoResidencia: cliente.tempoResidencia,
            tipoResidencia: String(cliente.tipoMoradia)
        };
    }
    getRelatorioCobranca(dataInicial, dataFinal, agente) {
        const params = (agente ? { agente, dataInicial, dataFinal } : { dataInicial, dataFinal });
        return this.restService.get('relatorio/cobranca', { params });
    }
    getRelatorioCobrancaParcela(dataInicial, dataFinal, agente) {
        const params = (agente ? { agente, dataInicial, dataFinal } : { dataInicial, dataFinal });
        return this.restService.get('relatorio/cobranca/parcela', { params });
    }
    getAgentesUsuarioLogado() {
        return this.restServiceGeral.get('usuario/agentes');
    }
}
